// @vendors
import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';

// @mutations
import { PROCESS_TENDER } from 'api/mutations';

// @context
import { useCommittedCapacityContext } from '../../context/committed-capacity.context';

// @components
import { ErrorBooking, SuccessFullyBooking } from '../ProcessingTender/ProcessingTender';
import DeclinedTender from '../ProcessingTender/DeclinedTender/DeclinedTender';
import { CommittedCapacityLandingPageSpinner } from '../LandingPage/LandingPage';

function LightCommittedCapacity() {
  const [loadingMessage, setLoadingMessage] = useState('Processing Load');
  const [errorMessage, setErrorMessage] = useState('');
  const { shouldBeBooked, tenderNumber } = useCommittedCapacityContext();

  const [ processTender ] = useMutation(PROCESS_TENDER, {
    onCompleted: () => {
      setLoadingMessage('');
      setErrorMessage('');
    },
    onError: (error) => {
      setErrorMessage(error.message);
      setLoadingMessage('');
    },
    context: {
      timeout: 100000
    }
  });

  useEffect(
    () => {
      processTender({
        variables: { loadTenderId: tenderNumber, isAccepted: shouldBeBooked }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (loadingMessage) {
    return <CommittedCapacityLandingPageSpinner message={loadingMessage} />
  }

  if (errorMessage) {
    return <ErrorBooking subtitle={errorMessage} />
  }

  if (!shouldBeBooked) {
    return <DeclinedTender />
  }

  return <SuccessFullyBooking />;
}

export default LightCommittedCapacity
